module.exports = __webpack_public_path__ + "static/media/557JamesPBrawleyDrNW_2018-06-12_103.f0de0361.jpg";